/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ul[_ngcontent-%COMP%]{margin:0 0 10px;text-align:left}li[_ngcontent-%COMP%]{color:#ec3c3c;font-size:12px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/common-theme/form-error/form-error.component.scss.shim.ngstyle.js.pre-build-optimizer.js